import { UI } from "@/constants";
import { SearchParams } from "@/types";

type ServerFetchProps = {
  path: string;
  params?: SearchParams;
};

export const serverFetch = async <T>({ path, params }: ServerFetchProps) => {
  const baseUrl = process.env.API_BASE_URL;
  const token = process.env.API_TOKEN;
  if (!baseUrl || !token) throw new Error(UI.errors.missingEnvironments);

  const url = new URL(path, baseUrl);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined) return;
      if (Array.isArray(v)) {
        v.forEach((val) => url.searchParams.append(k, val));
      } else {
        url.searchParams.set(k, v);
      }
    });
  }

  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
    cache: "force-cache",
    next: { revalidate: 300, tags: ["users-top"] },
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`API ${response.status}: ${text || response.statusText}`);
  }

  return (await response.json()) as T;
};
